<template>
  <img
    v-if="!isError"
    class="background-style swiper-lazy"
    :data-src="src"
    @error="onError"
  />
  <img
    v-if="!isError"
    :data-src="src"
    class="swiper-main__slide__win swiper-lazy"
    @error="onError"
  />
  <div class="spinner-lazy-preloader">
    <scale-loader
      :loading="!isInitLoader && isActiveSlide"
      :color="'#3921e3'"
    />
  </div>
  <span
    v-if="isError"
    class="swiper-main__slide__win"
    :style="{
      backgroundImage: `url('https://io.winwinapp.ru/images/Photo.png')`,
    }"
  />
  <img
    v-if="isError"
    class="swiper-main__slide__win"
    :src="'https://io.winwinapp.ru/images/Photo.png'"
  />
</template>

<script>
import ScaleLoader from './Spinner'

export default {
  name: 'OneImage',
  props: {
    src: String,
    realSlideIdx: Number,
    galleryIdx: Number,
  },
  components: {
    ScaleLoader,
  },
  methods: {
    onError() {
      this.isError = true
    },
  },
  data() {
    return {
      isError: false,
      isInitLoader: false,
    }
  },
  computed: {
    isActiveSlide() {
      return this.realSlideIdx === this.galleryIdx
    },
  },
  watch: {
    isActiveSlide(newValue, oldValue) {
      if (this.isInitLoader) {
        return
      }
      this.isInitLoader = !newValue && oldValue
    },
  },
}
</script>

<style scoped>
.spinner-lazy-preloader {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
}
.background-style {
  position: absolute;
  width: 100%;
  height: 100%;
  filter: blur(13px);
  opacity: 0.4;
}
</style>
